import BlogDetailPage from "@/pages/blog/components/BlogDetailPage";

export default function BlogLaravelPerformance() {
  return <BlogDetailPage slug="laravel-performance-optimization" />;
}